import React, { Fragment } from 'react'
import About from '../about/About'
import Contact from '../contact/Contact'
import Experiences from '../experiences/Experiences'
import Footer from '../footer/Footer'
import Header from '../header/Header'
import Hero from '../hero/Hero'
import Projects from '../projects/Projects'
import Services from '../services/Services'
import Testimonials from '../testimonial/Testimonials'

const Layout = () => {
  return (
    <Fragment>
        <Header />
        <Hero />
        <About />
        <Services />
        <Experiences />
        <Projects />
        <Testimonials />
        <Contact />
        <Footer />
    </Fragment>
  )
}

export default Layout